//Esto es para que funcione en ts
/* eslint-disable */
export function callSha256(val) {
    return sha256(val);
}

export function setQrCode(element, data) {
    return new QRCode(element, data)
}
/* eslint-enable */